import Button from '@mui/material/Button';
import styles from './continuebutton.module.css'

export default function ContinueButton(props) {
    const color = props.color;
    const click = props.onClick;

    return(
        <Button className={styles.continuebutton} onClick={click} sx={{bgcolor: color + '.dark', color: 'black', fontWeight: 'bold', fontSize: 18, borderRadius: 15, width: 500, height: 50, ':hover': {
            bgcolor: color + '.light'
          }}}>Devam</Button>
    )
}